module.exports = __webpack_public_path__ + "img/vc.475f7d86.svg";